import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE_QUERY_KEY,
  TeamCustomizableKnowledgeBase,
  teamCustomizableKnowledgeBaseApi,
} from '../../api/resources/team-customizable-knowledge-base';
import { useContext } from 'react';
import { ModuleContext } from '../../components/utils/module/ModuleContext';

export function useTeamKnowledgeBases<TResult = TeamCustomizableKnowledgeBase[]>(
  options?: Partial<UseQueryOptions<TeamCustomizableKnowledgeBase[], unknown, TResult>>
) {
  const { module } = useContext(ModuleContext);

  return useQuery({
    ...options,
    queryKey: [module?.type, module?.id, TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE_QUERY_KEY],
    queryFn: teamCustomizableKnowledgeBaseApi.getList,
    initialData: [],
  });
}
